import { Pipe, PipeTransform } from '@angular/core';
import { CodeService } from '../../shared/init/code.service';

@Pipe({
  name: 'categoryCode',
})
export class CategoryCodePipe implements PipeTransform {
  constructor(private codeService: CodeService) {}

  transform(code: string, seperator?: string): any {
    seperator = seperator || ' > ';
    return this.codeService.getDisplayCategoryNameAsDepth(code).join(seperator);
  }
}
